import { Link } from "react-router-dom";
import { ArrowUpRight, FolderCode, MessageSquare } from "lucide-react";

export default function ApplicationCard({ application }) {
  return (
    <Link className="card app-card" to={`/dashboard/applications/${application.id}`}>
      <div className="app-card-head">
        <span className="app-icon" aria-hidden="true">
          <FolderCode size={21} strokeWidth={1.8} />
        </span>
        <div className="app-card-title">
          <h3>{application.title}</h3>
          <span className="app-id">شناسه {application.id}</span>
        </div>
        <ArrowUpRight className="app-card-go" size={18} strokeWidth={2} aria-hidden="true" />
      </div>

      <code className="app-path" title={application.path}>
        {application.path}
      </code>

      <span className="app-card-action">
        <MessageSquare size={15} strokeWidth={1.9} aria-hidden="true" />
        گفت‌وگو با ایجنت
      </span>
    </Link>
  );
}
